import { computed, ref } from "vue";
import { defineStore } from "pinia";

export const useFeaturesStore = defineStore("features", () => {
  // State
  const _isCnameEnabled = ref<boolean>(false);
  const _isSamlCertificateEnabled = ref<boolean>(false);
  const _isDnsManualFailoverPolicyEnabled = ref<boolean>(false);
  const _isSaasTokenEnabled = ref<boolean>(false);
  const _isStorageBreakdownEnabled = ref<boolean>(false);
  const _isLogStreamerMultiJpdEnabled = ref<boolean>(false);

  // Getters
  const isCnameEnabled = computed(() => _isCnameEnabled.value);
  const isSamlCertificateEnabled = computed(
    () => _isSamlCertificateEnabled.value,
  );
  const isDnsManualFailoverPolicyEnabled = computed(
    () => _isDnsManualFailoverPolicyEnabled.value,
  );
  const isSaasTokenEnabled = computed(() => _isSaasTokenEnabled.value);
  const isStorageBreakdownEnabled = computed(
    () => _isStorageBreakdownEnabled.value,
  );
  const isLogStreamerMultiJpdEnabled = computed(
    () => _isLogStreamerMultiJpdEnabled.value,
  );

  // Actions
  const setIsCnameEnabled = (enabled: boolean) => {
    _isCnameEnabled.value = enabled;
  };

  const setIsSamlCertificateEnabled = (enabled: boolean) => {
    _isSamlCertificateEnabled.value = enabled;
  };

  const setIsDnsManualFailoverPolicyEnabled = (enabled: boolean) => {
    _isDnsManualFailoverPolicyEnabled.value = enabled;
  };

  const setIsSaasTokenEnabled = (enabled: boolean) => {
    _isSaasTokenEnabled.value = enabled;
  };

  const setIsStorageBreakdownEnabled = (enabled: boolean) => {
    _isStorageBreakdownEnabled.value = enabled;
  };

  const setIsLogStreamerMultiJpdEnabled = (enabled: boolean) => {
    _isLogStreamerMultiJpdEnabled.value = enabled;
  };

  return {
    isCnameEnabled,
    isSamlCertificateEnabled,
    isDnsManualFailoverPolicyEnabled,
    isSaasTokenEnabled,
    isStorageBreakdownEnabled,
    isLogStreamerMultiJpdEnabled,
    setIsCnameEnabled,
    setIsSamlCertificateEnabled,
    setIsDnsManualFailoverPolicyEnabled,
    setIsSaasTokenEnabled,
    setIsStorageBreakdownEnabled,
    setIsLogStreamerMultiJpdEnabled,
  };
});
